// ==========================
// EXPRESS SIGNS CALCULATOR ENGINE
// FINAL CORRECTED VERSION
// ==========================

window.ES_CALC = (function () {
  const VARIANTS = {
    yard: {
      "12x18": [
        { min: 1, max: 9, id: 43249326260283, price: 15 },
        { min: 10, max: 24, id: 43249326293051, price: 10 },
        { min: 25, max: 49, id: 43249326325819, price: 7 },
        { min: 50, max: 99, id: 43249326358587, price: 5 },
        { min: 100, max: 249, id: 43249326391355, price: 4 },
        { min: 250, max: 999999, id: 43249326424123, price: 3 }
      ],

      "18x24": [
        { min: 1, max: 9, id: 43249342054459, price: 25 },
        { min: 10, max: 24, id: 43249342087227, price: 15 },
        { min: 25, max: 49, id: 43249342119995, price: 12 },
        { min: 50, max: 99, id: 43249342152763, price: 8 },
        { min: 100, max: 250, id: 43249342185531, price: 6 },
        { min: 251, max: 999999, id: 43249342218299, price: 5 }
      ],

      "24x36": [
        { min: 1, max: 4, id: 43249429708859, price: 45 },
        { min: 5, max: 9, id: 43249429741627, price: 35 },
        { min: 10, max: 24, id: 43249429774395, price: 25 },
        { min: 25, max: 49, id: 43249429807163, price: 18 },
        { min: 50, max: 999999, id: 43249429839931, price: 12 }
      ],

      "4x8": [
        { min: 1, max: 4, id: 43403835047995, price: 165 },
        { min: 5, max: 9, id: 43403835080763, price: 140 },
        { min: 10, max: 24, id: 43403835113531, price: 115 },
        { min: 25, max: 49, id: 43403835146299, price: 90 },
        { min: 50, max: 999999, id: 43403835179067, price: 60 }
      ]
    },

    banners: {
      "2x3": { id: 43252563902523, price: 40 },
      "3x5": { id: 43252571242555, price: 69 },
      "4x8": { id: 43252573732923, price: 100 }
    }
  };

  const ADDONS = {
    stakes: { id: 43245928153147, price: 2 },
    sameDay: { id: 43244298600507, price: 50 },
    nextDay: { id: 43244302991419, price: 25 },
    double: {
      "12x18": { id: 43248417046587, price: 2 },
      "18x24": { id: 43248413081659, price: 3 },
      "24x36": { id: 43248414523451, price: 7 },
      "4x8": { id: 43403839504443, price: 30 }
    }
  };

  function getYardTier(size, qty) {
    const tiers = VARIANTS.yard[size];
    if (!tiers) return null;
    return tiers.find((tier) => qty >= tier.min && qty <= tier.max) || null;
  }

  function getBaseUnitPrice(type, size, qty) {
    if (type === "yard") {
      const tier = getYardTier(size, qty);
      return tier ? tier.price : 0;
    }

    if (type === "banner") {
      return VARIANTS.banners[size] ? VARIANTS.banners[size].price : 0;
    }

    return 0;
  }

  function calculate(type, size, qty, options = {}) {
    const safeQty = Math.max(1, parseInt(qty, 10) || 1);
    const unitPrice = getBaseUnitPrice(type, size, safeQty);
    const baseTotal = unitPrice * safeQty;

    let doubleTotal = 0;
    let stakesTotal = 0;
    let rushTotal = 0;

    if (options.double && ADDONS.double[size]) {
      doubleTotal = ADDONS.double[size].price * safeQty;
    }

    if (options.stakes) {
      const stakeQty = options.stakeQty != null
        ? Math.max(0, parseInt(options.stakeQty, 10) || 0)
        : safeQty;
      stakesTotal = ADDONS.stakes.price * stakeQty;
    }

    if (options.sameDay) {
      rushTotal += ADDONS.sameDay.price;
    } else if (options.nextDay) {
      rushTotal += ADDONS.nextDay.price;
    }

    const total = baseTotal + doubleTotal + stakesTotal + rushTotal;

    return {
      unitPrice,
      baseTotal,
      doubleTotal,
      stakesTotal,
      rushTotal,
      total
    };
  }

  function addToCart(type, size, qty, options = {}) {
    const safeQty = Math.max(1, parseInt(qty, 10) || 1);
    const items = [];

    if (type === "yard") {
      const tier = getYardTier(size, safeQty);
      if (!tier) {
        throw new Error(`No yard sign tier found for size ${size} and qty ${safeQty}`);
      }
      items.push({
        id: tier.id,
        quantity: safeQty
      });
    } else if (type === "banner") {
      const banner = VARIANTS.banners[size];
      if (!banner) {
        throw new Error(`No banner variant found for size ${size}`);
      }
      items.push({
        id: banner.id,
        quantity: safeQty
      });
    } else {
      throw new Error(`Unsupported product type: ${type}`);
    }

    if (options.stakes) {
      const stakeQty = options.stakeQty != null
        ? Math.max(0, parseInt(options.stakeQty, 10) || 0)
        : safeQty;

      if (stakeQty > 0) {
        items.push({
          id: ADDONS.stakes.id,
          quantity: stakeQty
        });
      }
    }

    if (options.double && ADDONS.double[size]) {
      items.push({
        id: ADDONS.double[size].id,
        quantity: safeQty
      });
    }

    if (options.sameDay) {
      items.push({
        id: ADDONS.sameDay.id,
        quantity: 1
      });
    } else if (options.nextDay) {
      items.push({
        id: ADDONS.nextDay.id,
        quantity: 1
      });
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items })
    }).then(() => {
      window.location.href = "/checkout";
    });
  }

  return {
    calculate,
    addToCart,
    getBaseUnitPrice,
    getYardTier,
    variants: VARIANTS,
    addons: ADDONS
  };
})();